export const TRANSFORM = Symbol('Transform');

import ModelKeyRepository from 'repositories/ImmutableRepository';

import KeyModifier from 'repositories/modifier/ExpandKeyModifier';

const preMatchRepository = new ModelKeyRepository();
const menuRepository = new ModelKeyRepository();
const liveRepository = new ModelKeyRepository();
const stakeOfTheDayRepository = new ModelKeyRepository();
const popularMatchesRepository = new ModelKeyRepository();
const timetableRepository = new ModelKeyRepository();

function transformData(data, transformType, section) {
    let repo;
    let modifier;

    if (section === 'preMatch') {
        repo = preMatchRepository;
    } else if (section === 'live') {
        repo = liveRepository;
    } else if (section === 'menu') {
        repo = menuRepository;
    } else if (section === 'stakeOfTheDay') {
        repo = stakeOfTheDayRepository;
    } else if (section === 'popularMatches') {
        repo = popularMatchesRepository;
    } else if (section === 'timetable') {
        repo = timetableRepository;
    }

    if (!repo) {
        return data;
    }

    if (transformType === 'init' || transformType === 'update') {
        modifier = new KeyModifier(repo);
    }

    if (modifier) {
        modifier.modify(data);
    }

    return data;
}

export default store => next => action => { //eslint-disable-line no-unused-vars
    const transform = action[TRANSFORM];
    if (typeof transform === 'undefined') {
        return next(action);
    }

    const {transformType, section, provider} = transform;
    const type = action.type;
    const data = action.data;

    let content;
    if (typeof provider === 'function') {
        content = provider(data);
    }

    if (!content) {
        return next(action);
    }

    function actionWith(data) {
        const finalAction = Object.assign({}, action, data);
        delete finalAction[TRANSFORM];
        return finalAction;
    }

    const transformedData = transformData(content, transformType, section);

    return next(actionWith({
        type,
        data: transformedData,
        section
    }));
};



// WEBPACK FOOTER //
// ./js/middleware/transform.js